import AddCustomMedicalItemAmountField from "./AddCustomMedicalItemAmountField";
import AddCustomMedicalItemProviderField from "./AddCustomMedicalItemProviderField";
import AddCustomMedicalItemTypeField from "./AddCustomMedicalItemTypeField";

export default function AddCustomMedicalItemForm({
  formValues,
  onChange,
  onProviderSearch,
  providerOptions,
  settlementTypeOptions,
  isLoadingProviders,
}) {
  const selectedType =
    settlementTypeOptions.find((option) => option.id === formValues.settlementType) ?? null;
  const selectedProvider =
    providerOptions.find((option) => option.id === formValues.providerId) ?? null;

  return (
    <div className="flex flex-col gap-4 p-6">
      <AddCustomMedicalItemTypeField
        settlementTypeOptions={settlementTypeOptions}
        selectedType={selectedType}
        onChange={onChange}
      />
      <AddCustomMedicalItemProviderField
        providerOptions={providerOptions}
        selectedProvider={selectedProvider}
        isLoadingProviders={isLoadingProviders}
        onChange={onChange}
        onProviderSearch={onProviderSearch}
      />
      <AddCustomMedicalItemAmountField
        value={formValues.settledAmount}
        onChange={onChange}
      />
    </div>
  );
}
